import { render, staticRenderFns } from "./showBox.vue?vue&type=template&id=ac6122b2&scoped=true&"
import script from "./showBox.vue?vue&type=script&lang=js&"
export * from "./showBox.vue?vue&type=script&lang=js&"
import style0 from "./showBox.vue?vue&type=style&index=0&id=ac6122b2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6122b2",
  null
  
)

export default component.exports